module.exports = __webpack_public_path__ + "img/40_69_003_060.4cb2c813.jpg";